import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: left;
  justify-content: left;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 10px;
  width: calc(100% - 60px);
  text-align: center;
  border: '1px solid gray';
`;

// Pour le format markdown
export const TitleMarkdown = styled.div`
  font-size: 1em;
  color: #555;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.5;

  p {
    margin: 0 0 10px;
  }
  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  ul,
  ol {
    margin-left: 20px;
  }
`;

// Pour le format texte simple
export const TitleText = styled.div`
  font-size: 1.2em;
  color: #333;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.4;
  white-space: pre-wrap;
`;

// Pour le format HTML
export const TitleHTML = styled.div`
  font-size: 1em;
  color: #333;
  margin-bottom: 20px;
  text-align: left;

  /* Styles pour certaines balises HTML communes */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 10px 0;
  }

  p {
    margin: 8px 0;
  }

  ul,
  ol {
    margin-left: 20px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 15px 0;
  }

  th,
  td {
    padding: 8px;
    border: 1px solid #ddd;
  }

  th {
    background-color: #f2f2f2;
  }
`;

// Pour le format markdown (description)
export const Description = styled.div`
  font-size: 1em;
  color: #333;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.5;

  p {
    margin: 0 0 10px;
  }
  strong {
    font-weight: normal;
  }
  em {
    font-style: normal;
  }
  ul,
  ol {
    margin-left: 20px;
  }
`;

// Pour le format texte simple (description)
export const DescriptionText = styled.div`
  font-size: 0.95em;
  color: #555;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.4;
  white-space: pre-wrap;
`;

// Pour le format HTML (description)
export const DescriptionHTML = styled.div`
  font-size: 0.95em;
  color: #555;
  margin-bottom: 20px;
  text-align: left;

  /* Styles pour certaines balises HTML communes */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 6px 0;
  }

  ul,
  ol {
    margin-left: 20px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 12px 0;
  }

  th,
  td {
    padding: 6px;
    border: 1px solid #ddd;
  }

  th {
    background-color: #f2f2f2;
  }

  pre,
  code {
    background-color: #f5f5f5;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: monospace;
  }
`;

// Updated to display buttons in a row with wrapping
export const OptionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin: 0 0 20px;
  padding: 0;
`;

// Changed from li to div for horizontal layout
export const OptionItem = styled.div`
  display: inline-block;
  margin: 5px;
`;

export const OptionButton = styled.button`
  padding: 10px 20px;
  font-size: 1em;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;

  &:hover {
    background-color: #0056b3;
  }
`;

export const CloseButton = styled.button`
  padding: 10px 15px;
  font-size: 0.9em;
  color: #333;
  background-color: #f1f1f1;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #e0e0e0;
  }
`;
